import Button from '@mui/material/Button';
import CssBaseline from '@mui/material/CssBaseline';
import TextField from '@mui/material/TextField';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Container from '@mui/material/Container';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { styled } from '@mui/material/styles';
import Paper from '@mui/material/Paper';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import md5 from 'blueimp-md5';
import { useCookies } from "react-cookie";
import { fetchGetUsuario } from '../reducers/fetchWebService';
import { useNavigate } from 'react-router-dom';
import { setIndex } from '../reducers/componentesHome';
import { useDispatch } from 'react-redux';
import { useMsal } from "@azure/msal-react";
import { isAdEnabled, loginRequest, TenantConfig } from '../authConfig';
import { useEffect, useState } from "react";
import { useLocation } from 'react-router-dom';
import { fetchTenant } from '../reducers/fetchWebService';

const Login = () => {
  const theme = createTheme();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [cookies, setCookie] = useCookies();
  const [ urlLogo, setUrlLogo ] = useState('');
  const [tenant, setTenant] = useState<TenantConfig | null>(null);
  const [redirectingAD, setRedirectingAD] = useState(false);

  const { instance } = useMsal();

  const location = useLocation();

  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    const errorLogin = queryParams.get('errorLogin');

    if (errorLogin == "1") {
      alert("Sus credenciales no están vinculadas a los grupos del sistema Controlite. Contáctese con el área de sistemas.");
    } else if (errorLogin == "2") {
      alert("No fue posible completar el ingreso con Active Directory. Intente nuevamente.");
    }

    const traerTenant = async () => {
      try {
        const tenantResponse = await fetchTenant() as TenantConfig;
        setTenant(tenantResponse);
        setUrlLogo("https://virtec.controlite.com.ar/Content/V2_Template/img/logo_" + tenantResponse.Id_Tenant + ".png");
      } catch (error) {
        console.error('No se pudo obtener la configuración del tenant', error);
      }
    }

    traerTenant();
    // Resto de tu lógica de inicio de sesión
  }, [location.search]);

  const handleIndex = async (id) => {
    if(!cookies.datosHome) {
      setCookie('datosHome', [
        {
          userId: id,
          abiertos: [], 
          columnas: [ 6,6,6,6,6,6,6,6,6 ], // ancho
          componentes: [ '1', '2', '3', '4', '5', '6', '7', '8', '9' ], // orden
        }
      ], {maxAge: 99999999, path: '/'});
    } else {
      let arrayDatos = cookies.datosHome;
      const userIndex = arrayDatos?.findIndex((element) => element.userId === id) ?? 0;
      await dispatch(setIndex(userIndex >= 0 ? userIndex : 0));
      
    }
  }

  const handleSubmitAD = async (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();

    if (!isAdEnabled(tenant) || redirectingAD) {
      return;
    }

    setRedirectingAD(true);
    try {
      await instance.loginRedirect(loginRequest);
    } catch (error) {
      console.error('No se pudo iniciar el ingreso por Active Directory', error);
      setRedirectingAD(false);
      alert('No fue posible conectarse con Active Directory. Intente nuevamente.');
    }
  };

  const handleSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
  
    const data = new FormData(event.currentTarget);
    const user = data.get('email');
    const pass = md5(String(data.get('password')));
  
    try {
      const res = await fetchGetUsuario(user, pass);
  
      // Validación real
      if (res && res.Id_User && res.Id_User !== 0) {
        setCookie('Id_User', res.Id_User, { path: '/' });
        await handleIndex(res.Id_User);
        navigate('/');
      } else {
        alert("Usuario o contraseña incorrectos");
      }
  
    } catch (error: any) {
      console.error(error);
  
      if (error.message?.includes('403') || error.message?.includes('401')) {
        alert("Usuario o contraseña incorrectos");
      } else {
        alert("Ha ocurrido un error al loguearse");
      }
    }
  };
  

  const Item = styled(Paper)(({ theme }) => ({
    backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#fff',
    ...theme.typography.body2,
    padding: theme.spacing(1),
    textAlign: 'center',
    color: theme.palette.text.secondary,
  }));

  return (
    <>
    <Box sx={{ flexGrow: 1 }}>
      <AppBar position="static" style={{backgroundColor: "#31A1E8", boxShadow: "0px 0px 0px 0px"}}>
        <Toolbar>
          <img src={urlLogo} alt="logo" style={{maxHeight:'78px'}} />
        </Toolbar>
      </AppBar>
    </Box>
    
    <ThemeProvider theme={theme}>
      <Grid container spacing={2}>
        {isAdEnabled(tenant) && <Grid item xs={12} sm={12} md={6}>
          <Item>
            <Container component="main" maxWidth="xs">
              <CssBaseline />
                <Box
                sx={{
                    marginTop: 8,
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                }}
                >
                <Typography component="h1" variant="h5" color="primary" style={{color: "#2b4277", marginBottom: "63px"}}>
                  {tenant.Name ? `Ingreso ${tenant.Name}` : 'Ingreso con Active Directory'}
                </Typography>
                <Typography component="h1" variant="h5" color="primary" style={{color: "#31A1E8"}}>
                  Sistema de Control de Acceso
                </Typography>
                <Box component="form" onSubmit={handleSubmitAD} noValidate sx={{ mt: 1 }}>
                  <Typography component="h1" variant="h6">
                  Ingrese con su cuenta corporativa
                  </Typography>
                  <Button
                    type="submit"
                    fullWidth
                    variant="contained"
                    disabled={redirectingAD}
                    sx={{ mt: 3, mb: 2 }}
                    style={{backgroundColor: "#31A1E8"}}
                  >
                    {redirectingAD ? 'Redirigiendo...' : 'Ingresar con Active Directory'}
                  </Button>
                </Box>
              </Box>
            </Container>
          </Item>
        </Grid>}

        <Grid item xs={12} sm={12} md={isAdEnabled(tenant) ? 6 : 12}>
          <Item>
            <Container component="main" maxWidth="xs">
              <CssBaseline />
              <Box
              sx={{
                  marginTop: 8,
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
              }}
              >
                <Typography component="h1" variant="h5" color="primary" style={{color: "#2b4277"}}>
                  {/* Ingreso Secundario */}
                  Ingreso
                </Typography>
                <Box component="form" onSubmit={handleSubmit} noValidate sx={{ mt: 1 }}>
                  <TextField
                    margin="normal"
                    required
                    fullWidth
                    id="email"
                    label="Ingrese su usuario"
                    name="email"
                    autoComplete="email"
                    autoFocus
                  />
                  <TextField
                    margin="normal"
                    required
                    fullWidth
                    name="password"
                    label="Contraseña"
                    type="password"
                    id="password"
                    autoComplete="current-password"
                  />
                  <Button
                    type="submit"
                    fullWidth
                    variant="contained"
                    sx={{ mt: 3, mb: 2 }}
                    style={{backgroundColor: "#31A1E8"}}
                  >
                    Ingresar
                  </Button>
                </Box>
              </Box>
            </Container>
          </Item>
        </Grid>
      </Grid>
    </ThemeProvider>
    </>
  );
}

export default Login;
